module.exports = __webpack_public_path__ + "static/media/activity-flashcard.73fea10d.png";